import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { Spinner } from '@trinity/chat-components/components/presentation/Spinner.js';
import { useAppReadyState } from '@/containers/AppReadyState/hooks';

export function OAuth2Logout() {
  const navigate = useNavigate();
  const app = useAppReadyState();

  useEffect(() => {
    if (app.initialized) {
      navigate('/logout');
    }
  }, [app.initialized, navigate]);

  return (
    <Root>
      <Spinner />
    </Root>
  );
}

const Root = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '80vh',
});